import React, { useState } from 'react';
import { TextBoxLayoutStyle, UrlBox } from '@apply/components';
import { sectionHeaderStyle } from '../constants/styles';

export const UrlBoxPanel: React.FC = () => {
    const [website, set_website] = useState('');

    return (
        <>
            <h6 style={sectionHeaderStyle}>URL Components:</h6>
            <div style={{ marginBottom: '1rem' }}>
                <UrlBox
                    id='website'
                    value={website}
                    onChange={set_website}
                    label='Website'
                    required={true}
                    width='100%'
                />
            </div>
            <div style={{ marginBottom: '1rem' }}>
                <UrlBox
                    id='website'
                    value={website}
                    onChange={set_website}
                    label='Website'
                    required={true}
                    width='100%'
                    showInfoIcon={true}
                    infoText='Your Website'
                />
            </div>
            <div style={{ marginBottom: '1rem' }}>
                <UrlBox
                    id='website'
                    value={website}
                    onChange={set_website}
                    label='Website (Horiz.)'
                    required={true}
                    width='100%'
                    layoutStyle={TextBoxLayoutStyle.Horizontal}
                    labelWidth='120px'
                />
            </div>
            <div style={{ marginBottom: '1rem' }}>
                <UrlBox
                    id='website'
                    value={website}
                    onChange={set_website}
                    label='Website (Horiz.)'
                    required={true}
                    width='100%'
                    showInfoIcon={true}
                    infoText='Your Website'
                    layoutStyle={TextBoxLayoutStyle.Horizontal}
                    labelWidth='150px'
                />
            </div>
        </>
    );
};
